import { RestBase } from './base'
import { User } from '@/ts/interfaces/user'
import { Grant, GrantIn } from '@/ts/interfaces/grant'

export class RestUser {
  private rest: RestBase

  constructor() {
    this.rest = new RestBase()
  }

  public signup(token: string, partyId: number, name: string, displayName: string, country: string, email: string, profilePicture: string | null, profileSticker: string | null, isCompetition?: boolean) {
    return this.rest.post(`/api/parties/${partyId}/users`, {
      headers: this.rest.bearerAuthorizationHeader(token),
      body: {
        real_name: name,
        display_name: displayName,
        country: country === '' ? undefined : country,
        email: email === '' ? undefined : email,
        profile_picture: profilePicture,
        profile_sticker: profileSticker,
        competition_accepted: isCompetition,
      },
    })
  }

  public async getAllBlocked(token: string, partyId: number): Promise<{ items: User[] }> {
    return this.rest.get(`/api/parties/${partyId}/users?can_chat=False`, {
      headers: this.rest.bearerAuthorizationHeader(token),
    })
  }

  public getParty(token: string, partyId: number): Promise<User> {
    return this.rest.get(`/api/parties/${partyId}/users/me`, {
      headers: this.rest.bearerAuthorizationHeader(token),
    })
  }

  public getSystem(token: string): Promise<any> {
    return this.rest.get('/api/users/me', {
      headers: this.rest.bearerAuthorizationHeader(token),
    })
  }

  public getServiceToken(token: string): Promise<{ expires_at: number, token: string }> {
    return this.rest.get('/api/users/me/service_token', {
      headers: this.rest.bearerAuthorizationHeader(token),
    })
  }

  public async logout(token: string) {
    try {
      await this.rest.delete('/api/auth/session', {
        headers: this.rest.bearerAuthorizationHeader(token),
      })
    } catch (err) {
    }
  }

  public grant(partyId: number, data: GrantIn) {
    return this.rest.post(`/api/parties/${partyId}/grants`, { body: data, withCmsAuth: true, })
  }

  public revokeGrant(partyId: number, service: string, serviceId: string | null, grantToken: string | null) {
    let path = `/api/parties/${partyId}/grants`
    if (serviceId) {
      path += `/${service}/${encodeURIComponent(serviceId)}`
    } else if (grantToken) {
      path += `/${grantToken}`
    } else {
      return
    }
    return this.rest.delete(path, { withCmsAuth: true, })
  }

  public getGrants(partyId: number): Promise<Grant[]> {
    return this.rest.get(`/api/parties/${partyId}/grants`, { withCmsAuth: true, })
  }

  public block(token: string, partyId: number, userId: number): Promise<void> {
    return this.rest.delete(`/api/parties/${partyId}/users/${userId}/can_chat`, { headers: this.rest.bearerAuthorizationHeader(token), })
  }

  public unblock(token: string, partyId: number, userId: number): Promise<void> {
    return this.rest.put(`/api/parties/${partyId}/users/${userId}/can_chat`, { headers: this.rest.bearerAuthorizationHeader(token), })
  }

  public deleteAllUsers(partyId: number) {
    return this.rest.delete(`/api/parties/${partyId}/users`, { withCmsAuth: true })
  }

  public async loginApple(partyId: number, musicUserToken: string, grantToken: string | null): Promise<string> {
    // Login with apple music user token
    const data = await this.rest.post('/api/auth/apple/login', {
      body: {
        music_user_token: musicUserToken,
        grant_token: grantToken,
        party_id: partyId,
      },
    })
    return data.access_token
  }
}
